"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSideBySideToken = exports.createAccordionToken = exports.createImageToken = exports.createGoogleMapsToken = exports.createEmbedToken = exports.createBlockQuoteToken = exports.createListItemToken = exports.createParagraphToken = exports.createHeading2Token = exports.createHeading1Token = exports.createVideoToken = void 0;
var List_1 = require("@CommonFrontend/ContentTokens/Models/List");
var createVideoToken = function (options) {
    return __assign({ type: "block", subType: "video" }, options);
};
exports.createVideoToken = createVideoToken;
var createHeading1Token = function () { return ({
    type: "block",
    subType: "heading1",
}); };
exports.createHeading1Token = createHeading1Token;
var createHeading2Token = function () { return ({
    type: "block",
    subType: "heading2",
}); };
exports.createHeading2Token = createHeading2Token;
var createParagraphToken = function () { return ({
    type: "block",
    subType: "paragraph",
}); };
exports.createParagraphToken = createParagraphToken;
var createListItemToken = function (_a) {
    var _b = _a === void 0 ? {} : _a, level = _b.level, type = _b.type;
    return ({
        type: "block",
        subType: "listItem",
        level: level !== null && level !== void 0 ? level : 1,
        listType: type !== null && type !== void 0 ? type : List_1.ListItemType.Bullet,
    });
};
exports.createListItemToken = createListItemToken;
var createBlockQuoteToken = function () { return ({
    type: "block",
    subType: "blockQuote",
}); };
exports.createBlockQuoteToken = createBlockQuoteToken;
var createEmbedToken = function (options) {
    return __assign({ type: "block", subType: "iframe" }, options);
};
exports.createEmbedToken = createEmbedToken;
var createGoogleMapsToken = function (options) {
    return __assign({ type: "block", subType: "googleMaps" }, options);
};
exports.createGoogleMapsToken = createGoogleMapsToken;
var createImageToken = function (src, options) {
    var _a = options || {}, width = _a.width, alignment = _a.alignment, frame = _a.frame, uploadId = _a.uploadId, href = _a.href, alt = _a.alt, role = _a.role;
    var token = {
        type: "block",
        subType: "image",
        src: src || "",
    };
    if (width) {
        token.width = width;
    }
    if (href) {
        token.href = href;
    }
    if (alignment) {
        token.alignment = alignment;
    }
    if (uploadId) {
        token.uploadId = uploadId;
    }
    if (frame) {
        token.frame = frame;
    }
    if (alt) {
        token.alt = alt;
    }
    if (role) {
        token.role = role;
    }
    return token;
};
exports.createImageToken = createImageToken;
var createAccordionToken = function (heading, body) {
    return {
        type: "block",
        subType: "accordion",
        heading: heading,
        body: body,
    };
};
exports.createAccordionToken = createAccordionToken;
var createSideBySideToken = function (column1, column2) {
    return {
        type: "block",
        subType: "sideBySide",
        column1: column1,
        column2: column2,
        percent: 50,
        placeholderIndex: null,
        renderPlaceholder: false,
    };
};
exports.createSideBySideToken = createSideBySideToken;
